import { useChannelStateContext, useTypingContext } from 'stream-chat-react';

// TODO in POR-15598: move useChatClient out of legacy
// eslint-disable-next-line no-restricted-imports
import { useChatClient } from 'src/legacy/components/Chat/useChatClient';

export interface TypingStatusData {
  typingUsers: Array<{
    user?: {
      id?: string;
      name?: string;
    };
  }>;
}

export const useTypingStatus = (): TypingStatusData | null => {
  const { channelConfig } = useChannelStateContext();
  const chatClient = useChatClient();
  const { typing = {} } = useTypingContext();

  if (channelConfig?.typing_events === false) {
    return null;
  }

  const typingInChannel = Object.values(typing).filter(
    ({ user }) => user?.id !== chatClient?.user?.id,
  );

  if (!typingInChannel || typingInChannel.length === 0) {
    return null;
  }

  const result = {
    typingUsers: typingInChannel,
  };

  return result;
};
